<sk-modal-content [title]="fileName"
                  cancelBtnText="label.Close"
                  confirmByKeypress
                  [isHideCloseBtn]="true"
                  [ignoreBasisWidth]="true"
                  (closed)="closeWithoutResult()">

  <ng-container id="sk-modal-body">
    <div class="editor-modal-body">
      @if (accessToken() && accessTokenTtl()) {
        <form
            id="office-form"
            #officeForm
            [action]="wopiEditUrl"
            method="post"
            target="office-iframe"
        >
            <input name="access_token" [value]="accessToken()" type="hidden"/>
            <input name="access_token_ttl" [value]="accessTokenTtl()" type="hidden"/>
        </form>
      }
      <iframe
          name="office-iframe"
          sandbox="allow-downloads allow-forms allow-modals allow-orientation-lock allow-pointer-lock allow-popups allow-popups-to-escape-sandbox allow-presentation allow-same-origin allow-scripts allow-top-navigation allow-top-navigation-by-user-activation allow-top-navigation-to-custom-protocols"
          height="100%"
          width="100%">
      </iframe>
    </div>
  </ng-container>
</sk-modal-content>
